import { render } from "./LayoutHeader.vue?vue&type=template&id=4e4fdd2d&scoped=true"
import script from "./LayoutHeader.vue?vue&type=script&lang=js"
export * from "./LayoutHeader.vue?vue&type=script&lang=js"

import "./LayoutHeader.vue?vue&type=style&index=0&id=4e4fdd2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4fdd2d"]])

export default __exports__